import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { SettingsService } from '../services/indexed-db/object-stores/settings/settings.service';
import { ExaminationResult } from '../examinationResult.model';

export interface LeadDashboardResolve {
  draft?: ExaminationResult;
}

/**
 * This Resolver provides the current settings to LeadDashboardComponent by reading from indexedDb and passing it to ActivatedRoute
 *
 * Since LeadDashboardComponent provides LeadDashboardService this service can directly access the provided draft
 * and the service can be passed fully initialized to the constructor of LeadTaskComponent
 *
 */
@Injectable({ providedIn: 'root' })
export class LeadDashboardResolver implements Resolve<LeadDashboardResolve> {
  constructor(private settingsService: SettingsService) {}

  async resolve(): Promise<LeadDashboardResolve> {
    return new Promise((resolve) => {
      this.settingsService
        .getLeadWithExaminationResult()
        .then((leadWithExaminationResult) =>
          resolve({
            draft: leadWithExaminationResult.examinationResult,
          }),
        )
        .catch(() => resolve({}));
    });
  }
}
